import { Component } from "@angular/core";

import {
  Platform,
  IonApp,
  IonRouterOutlet,
  IonLabel,
  IonIcon,
  IonMenuToggle,
  IonList,
  IonContent,
  IonTitle,
  IonToolbar,
  IonHeader,
  IonMenu,
  IonSplitPane,
} from "@ionic/angular/standalone";
import { SplashScreen } from "@awesome-cordova-plugins/splash-screen/ngx";
import { StatusBar } from "@awesome-cordova-plugins/status-bar/ngx";
import { UserModel, UserService } from 'src/app/services/web-api-client';
import { NgxPermissionsService } from "ngx-permissions";
import { Router, RouterModule } from "@angular/router";
import { Storage } from "@ionic/storage-angular";
import { UserState } from "./shared/services/user.state";
import { EventTypes, OidcSecurityService, PublicEventsService } from "angular-auth-oidc-client";
import { AndroidNotch } from "@awesome-cordova-plugins/android-notch/ngx";
import { filter } from "rxjs";

import { IonRouterLink } from "@ionic/angular/standalone";
import { addIcons } from 'ionicons';
import { homeOutline, logoIonic, personOutline, swapHorizontal, swapHorizontalOutline } from 'ionicons/icons';

@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  imports: [
    IonApp,
    IonRouterOutlet,
    IonRouterLink,
    RouterModule,
    IonLabel,
    IonIcon,
    IonMenuToggle,
    IonList,
    IonContent,
    IonTitle,
    IonToolbar,
    IonHeader,
    IonMenu,
    IonSplitPane
],
})
export class AppComponent {
  public appPages = [
    {
      title: "Hjem",
      url: "/home",
      icon: "home-outline",
    },
    {
      title: "Skift organisation",
      url: "/login",
      icon: "swap-horizontal-outline",
    },
    {
      title: "Profil",
      url: "/profile",
      icon: "person-outline",
    },
    // {
    //   title: "Log ind",
    //   url: "/login",
    //   icon: "enter-outline",
    // },
    // {
    //   title: "Log ud",
    //   url: "/logout",
    //   icon: "exit-outline",
    // },
  ];
  filteredMenu = [];
  user: UserModel;
  hasPermission: boolean;
  logo: string;

  constructor(
    private platform: Platform,
    // private splashScreen: SplashScreen,
    // private statusBar: StatusBar,
    // private userState: UserState,
    // private permissionsService: NgxPermissionsService,
    private router: Router,
    // public oidcSecurityService: OidcSecurityService,
    // private eventService: PublicEventsService,
    private storage: Storage
  ) // private androidNotch: AndroidNotch
  {
    this.storage.create();
    this.initializeApp();
    addIcons({ homeOutline, swapHorizontal, swapHorizontalOutline, personOutline });
  }

  initializeApp() {
    this.platform.ready().then(() => {
      // this.statusBar.styleDefault();
      // this.splashScreen.hide();
      // this.router.navigateByUrl("/login");
      this.detectInsets();

      // this.storage.get('access_token').then(data => {
      //   let isExpired = true;// this.jwtTokenService.isTokenExpired(data);

      //   if (isExpired) {
      //     this.router.navigateByUrl('/login');
      //   }
      //   else {
      //     this.userService.getCurrentUser().subscribe(data => {
      //       this.user = this.userService.currentUser;
      //     });
      //   }
      // });
    });
  }

  loginWithPopup() {
    // this.oidcSecurityService.authorizeWithPopUp().subscribe(({ isAuthenticated, userData, accessToken }) => {
    //   console.log(isAuthenticated);
    //   console.log(userData);
    //   console.log(accessToken);
    //   this.getUser();
    // });
  }

  forceRefreshSession() {
    // this.oidcSecurityService.forceRefreshSession().subscribe((result) => console.warn(result));
  }

  logout() {
    // this.oidcSecurityService.logoff().subscribe((data) => {
    //   console.log("logged out");
    //   this.router.navigateByUrl("/login");
    // });
  }

  // Call this on resize or orientationchange, but *after* the deviceready event
  detectInsets() {
    const style = document.documentElement.style;

    // // Apply insets as css variables
    // this.androidNotch.hasCutout().then((px) => {
    //   console.error("Cutout: ", px);
    // });

    // this.androidNotch.getInsetTop().then(
    //   (px) => {
    //     console.error("Top: ", px);
    //     style.setProperty("--notch-inset-top", px + "px");
    //   },
    //   (err) => console.error("Failed to get insets top:", err)
    // );

    // this.androidNotch.getInsetRight().then(
    //   (px) => {
    //     style.setProperty("--notch-inset-right", px + "px");
    //   },
    //   (err) => console.error("Failed to get insets right:", err)
    // );

    // this.androidNotch.getInsetBottom().then(
    //   (px) => {
    //     style.setProperty("--notch-inset-bottom", px + "px");
    //   },
    //   (err) => console.error("Failed to get insets bottom:", err)
    // );

    // this.androidNotch.getInsetLeft().then(
    //   (px) => {
    //     style.setProperty("--notch-inset-left", px + "px");
    //   },
    //   (err) => console.error("Failed to get insets left:", err)
    // );
  }

  ngOnInit() {
    // this.oidcSecurityService.isAuthenticated$
    //   .pipe(
    //     filter((isAuthenticated) => isAuthenticated !== null) // Filter out initial null/undefined values
    //   )
    //   .subscribe((isAuthenticated) => {
    //     // Remove any existing login/logout item
    //     this.appPages = this.appPages.filter(
    //       (page) => page.title !== "Log ind" && page.title !== "Log ud"
    //     );
    //     // Add the appropriate item based on the authentication status
    //     if (isAuthenticated) {
    //       this.appPages.push({
    //         title: "Log ud",
    //         url: "/logout",
    //         icon: "exit-outline",
    //       });
    //     } else {
    //       this.appPages.push({
    //         title: "Log ind",
    //         url: "/login",
    //         icon: "enter-outline",
    //       });
    //     }
    //   });
    // this.eventService
    //   .registerForEvents()
    //   .pipe(
    //     filter(
    //       (notification) => notification.type === EventTypes.UserDataChanged
    //     )
    //   )
    //   .subscribe((value) => {
    //     console.log("CheckSessionChanged with value", value);
    //     this.userState.getCurrentUser();
    //   });
    // this.userState.userObservable.subscribe((data) => {
    //   this.user = data; // this.userService.currentUser;
    //   this.logo = this.user.logo;
    //   this.permissionsService.flushPermissions();
    //   if (this.user.permissions) {
    //     this.permissionsService.loadPermissions(this.user.permissions);
    //   }
    // });
    // this.configuration = this.oidcSecurityService.configuration;
    // this.userData$ = this.oidcSecurityService.userData$;
    // this.isAuthenticated$ = this.oidcSecurityService.isAuthenticated$;
    // this.storage.create();
    // this.oidcSecurityService.checkAuthIncludingServer().subscribe((isAuthenticated) => {
    //   if (!isAuthenticated) {
    //     // this.loginWithPopup();
    //   }
    //   else {
    //     this.getUser();
    //   }
    // });
  }

  private getUser() {
    // this.userState.getCurrentUser().subscribe(data => {
    //   this.user = this.userState.currentUser;
    //   // this.logo = this.user.logo;
    //   // "https://i1.wp.com/www.madsynergi.dk/wp-content/uploads/2018/09/Mad-Synergi-logo-stor-e1536654672211.png?w=1080&is-pending-load=1#038;ssl=1";
    //   // this.organization = this.user.organizations.findIndex(x => x.id == this.user.organizationId);
    //   this.permissionsService.flushPermissions();
    //   // this.permissionsService.loadPermissions(this.user.permissions);
    // });
  }
}
